import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "workspace" }
const _hoisted_2 = {
  class: "col-md-9 ms-sm-auto col-lg-10 px-md-4",
  "element-loading-text": "加载中"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "基本信息")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("main", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_descriptions, { title: "用户信息" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions_item, { label: "用户名：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.currentUser.username), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "手机号码：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.currentUser.mobile), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "用户类别：" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tag, { size: "small" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.currentUser.type === 0? '个人':'公司'), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "token：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.currentUser.token), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "userid：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.currentUser.userid), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_descriptions, {
        title: "概览数据",
        style: {"margin-top":"20px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions_item, { label: "充值金额(元)：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.currentUser.all_money ? _ctx.currentUser.all_money/100:''), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "实际充值金额(元)：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.currentUser.charge_money/100), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "调用上限(次)：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.currentUser.all_threshold), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "并发上限(路)：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.currentUser.concurrency), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_descriptions, {
        title: "实时数据",
        style: {"margin-top":"20px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions_item, { label: "最大并发：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.currentUser.max_concurrency_use), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "当前并发：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.currentUser.concurrency_use), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "使用总次数：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.currentUser.all_use), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "今日使用次数：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.currentUser.day_use), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 512), [
      [_directive_loading, _ctx.Loading]
    ])
  ]))
}